// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"29f30bc2","740":"554d139a"}[chunkId] + ".chunk.js";
};